module.exports = __webpack_public_path__ + "images/text.svg?6d01c598467173ab14f7840c93e7e190";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppDefaultLayout/components/sections/signboardNew/text.svg
// module id = 36e1a3731f73d4fdb3f9
// module chunks = 0